var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.$l('title_text_fabric_info') || '面料信息'))])}
var staticRenderFns = []

export { render, staticRenderFns }